import {CgSpinner} from 'react-icons/cg'

import 'twin.macro'

function Spinner(props: React.ComponentProps<'svg'>) {
  return <CgSpinner tw="animate-spin w-5 h-5" aria-label="Loading" {...props} />
}

export {Spinner}
